import { Box } from "@mui/material";

function Layer({ sx }) {
    return (
        <Box
            aria-hidden
            sx={{
                position: "fixed",
                inset: 0,
                pointerEvents: "none",
                ...sx,
            }}
        />
    );
}

export default function TilaaBackdrop({ children }) {
    return (
        <Box sx={{ position: "relative", isolation: "isolate", minHeight: "100%" }}>
            <Layer sx={{ zIndex: -5, backgroundColor: "background.default" }} />
            <Layer sx={{
                zIndex: -4,
                background: "radial-gradient(circle at 50% 18%, rgba(58,138,158,0.22) 0%, transparent 60%)",
            }} />
            <Layer sx={{
                zIndex: -3,
                backgroundImage: "url(/textures/concrete-grunge.svg)",
                backgroundSize: "400px 400px",
                backgroundRepeat: "repeat",
                mixBlendMode: "overlay",
                opacity: 0.10,
            }} />
            <Layer sx={{
                zIndex: -2,
                backgroundImage: "url(/textures/cityscape.webp)",
                backgroundSize: "cover",
                backgroundPosition: "center bottom",
                backgroundRepeat: "no-repeat",
                top: "auto",
                height: "62vh",
                bottom: 0,
                mixBlendMode: "multiply",
                opacity: 0.22,
            }} />
            <Layer sx={{
                zIndex: -1,
                background: "linear-gradient(to top, rgba(0,0,0,0.35) 0%, transparent 30%)",
            }} />
            <Box sx={{ position: "relative", zIndex: 0 }}>{children}</Box>
        </Box>
    );
}
